export const CRM_ROUTE_NAMES = {
  ADD_ACTIVITY: 'add-activity',
  BULK_REASSIGN: 'bulk-reassign',
  CALENDAR: 'calendar',
  CONTACT_RELATIONSHIPS: 'contact-relationships',
  CONTACTS_ADD: 'contacts-add',
  CONTACTS_EDIT: 'contacts-edit',
  CONTACTS: 'contacts',
  CREDITS: 'credits',
  CUSTOMER_ADD_WITH_ID: 'customer-add-with-id',
  CUSTOMER_ADD: 'customer-add',
  CUSTOMER_COMPANY: 'customer-company',
  CUSTOMER_EDIT: 'customer-edit',
  CUSTOMER_STATUSES: 'customer-statuses',
  CUSTOMERS: 'customers',
  DISTRIBUTION_ZONES_ADD: 'distribution-zones-add',
  DISTRIBUTION_ZONES_EDIT: 'distribution-zones-edit',
  DISTRIBUTION_ZONES: 'distribution-zones',
  FIND_BUYER: 'find-buyer',
  GROUPS: 'groups',
  IMPORT: 'import',
  MANAGE_TERRITORIES: 'manage-territories',
  SALES_FUNNEL: 'sales-funnel',
  SERVICE_ZONES: 'service-zones',
  TASKS: 'tasks',
  TEMPLATES: 'templates',
  TRANSFER_DATA: 'transfer-data',
};
